define([
	"dojo/_base/declare",
	"dijit/form/DropDownButton",
	"./ToolbarPlugin"
], function(declare,DropDownButton,ToolbarPlugin) {

	return declare([DropDownButton, ToolbarPlugin], {
		// String[]: array of plugin names in drop-down
		pluginChildren: null,
		
		postMixInProperties: function() {
			// summary: set appearance based on action
			if (this.defAction) {
				this._mixinActionProperties();
			}
			this.inherited(arguments);
		},

		/**
		 * Destroy existing drop down so that it will be recreated next time it is needed
		 */
		resetDropDown: function() {
			if (this._opened) {
				this.closeDropDown(true);
			}

			if (this.dropDown) {
				this.dropDown.destroyRecursive();
				delete this.dropDown;
			}			
		}
	});
});